// src/main.tsx
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './app/app';
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import './styles/layout/layout.scss';
import './styles/custom/custom-style.scss';
import './styles/demo/Demos.scss';
// import './../public/themes/flexiroam-light/theme.css';
import './assets/themes/flexiroam-light/theme.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <StrictMode>
    <App />
    {/* <div>Main Application Content</div> */}
    {/* </App> */}
  </StrictMode>
);
